import { memo } from 'react';
import { connect, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { Modal } from 'rsuite';
import { RootState } from '../../@types/RootState';
import gif from '../../assets/image/ipa-banner-lead.gif';
import { ReactComponent as Logo } from '../../assets/logo/logo-ipa-branco.svg';
import { selectorUser } from '../../lib/selectorUser';
import { sendLead } from '../../pages/ISA/InfoPanel/InfoPanel/utils';
import { selectorNavBarModals, SET_IS_OPEN } from '../../reducers/navBar/modals';
import { trackEvent } from '../../utils/MatomoConfig';
import styles from './ModalIPALead.module.scss';

type ModalIPALeadProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const ModalIPALead = ({ show, onHide }: ModalIPALeadProps) => {
  const user = useSelector(selectorUser);

  const handleClick = () => {
    const confirm = window.confirm('Deseja entrar em contato com a nossa equipe?');
    if (!confirm) return;
    sendLead(user, 'IPA');
    trackEvent('Upsell/Crossell', 'IPA');
    window.open('https://wa.me/551137779670?text=Ol%C3%A1%21+Quero+saber+mais+sobre+o+IPA+Software+de+Precifica%C3%A7%C3%A3o%21');
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} className={styles.modal}>
      <Modal.Body className={styles.modal__content}>
        <Logo className={styles.logo} />
        <h2 className={styles.title}>Garanta uma precificação mais inteligente com a versão completa do IPA</h2>
        <img src={gif} alt="Imagem animada demonstrando o funcionamento da aplicação" />
        <div className={styles['inner-container']}>
          <h3 className={styles.subtitle}>Tenha acesso total às funcionalidades que vão otimizar ainda mais seus resultados com o IPA Pro.</h3>
          <ul>
            <li>Consultoria especializada para definição das estratégias de precificação</li>
            <li>Crie regras de precificação automática e defina limites de margem ou competitividade</li>
            <li>Preveja a sua demanda futura de maneira fácil Crie campanhas promocionais, agrupadas por lojas e produtos</li>
            <li>Tenha visibilidade do desempenho de vendas, competitividade e performance do seu negócio no módulo de analytics</li>
          </ul>
        </div>
        <button onClick={handleClick}>fale com um especialista</button>
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  show: selectorNavBarModals(state).IPA,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onHide: () => dispatch(SET_IS_OPEN({ key: 'IPA', payload: false })),
});

export default memo(connect(mapStateToProps, mapDispatchToProps)(ModalIPALead));
